export const FLASHCARDS_EMBEDDING_DIMENSIONS = 768
export const FLASHCARDS_EMBEDDING_MODEL =
  'jinaai/jina-embeddings-v5-text-nano-retrieval:q8:prefixed-v1'
/** Turso folds identifiers; escaping preserves case-sensitive model identity. */
export function pageEmbeddingIndexName(slot: string, model: string, dimensions: number): string {
  const escaped = model.split('/').map(part => encodeURI(part)
    .replaceAll(/%[0-9A-F]{2}/g, escape => escape.toLowerCase())
    .replaceAll(/[A-Z]/g, char => '%' + (char.codePointAt(0) ?? 0).toString(16))).join('/')
  return `${slot.toLowerCase()}/${escaped}/${dimensions}`
}
export const FLASHCARDS_EMBEDDING_INDEX = {
  name: pageEmbeddingIndexName('pageTextEmbedding', FLASHCARDS_EMBEDDING_MODEL, FLASHCARDS_EMBEDDING_DIMENSIONS),
  vectorFn: 'vector8',
  dimensions: FLASHCARDS_EMBEDDING_DIMENSIONS,
} as const
/** Shared WITH clause for schema generation and model refresh. */
export function pageEmbeddingIndexOptions(index: { dimensions: number; vectorFn: 'vector8' | 'vector32' }): string {
  return `dimensions = ${index.dimensions}, type = '${index.vectorFn}'`
}
export const FLASHCARDS_EMBEDDING_TEXT_MAX_CHARS = 24_000
export const FLASHCARDS_EMBEDDING_BLOCK_MAX_CHARS = 2_000
